import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MailIcon, MapPinIcon, MenuIcon, XIcon } from 'lucide-react';
import { PROFILE, SECTIONS } from '../data/profile';
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [location.pathname]);
  return <header className="fixed inset-x-0 top-0 z-50 bg-navy-950/95 backdrop-blur" data-id="element-173" data-mp="2rlm931z3vmcl">
      {/* Utility row */}
      <div className="hidden border-b border-white/10 lg:block" data-id="element-174" data-mp="2wjfdbpgum6a8">
        <div className="mx-auto flex h-10 max-w-content items-center justify-between px-6 lg:px-8" data-id="element-175" data-mp="31d07f6fbmg45">
          <p className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-slateink-500" data-id="element-176" data-mp="36a0cbe0fpcto">
            <MapPinIcon className="h-3.5 w-3.5 text-gold-500" aria-hidden="true" data-id="element-177" data-mp="3bbfvt1myrb9y" />
            {PROFILE.location}
          </p>
          <a href={`mailto:${PROFILE.email}`} className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-slateink-300 transition-colors hover:text-gold-400" data-id="element-178" data-mp="3f9nfa48taqou">
            <MailIcon className="h-3.5 w-3.5 text-gold-500" aria-hidden="true" data-id="element-179" data-mp="2ro48ac6osxni" />
            {PROFILE.email}
          </a>
        </div>
      </div>

      {/* Identity row */}
      <div className="border-b border-white/10" data-id="element-180" data-mp="2hpeqejesjd79">
        <div className="mx-auto flex h-16 max-w-content items-center justify-between px-6 lg:h-[72px] lg:px-8" data-id="element-181" data-mp="3fbvldi01xepu">
          <Link to="/" className="flex items-center gap-3" data-id="element-182" data-mp="3abzglgjj5j98">
            <img src={PROFILE.portrait} alt="" aria-hidden="true" className="h-10 w-10 border border-gold-500/60 object-cover p-[2px]" data-id="element-183" data-mp="3aelppkm2k6tk" />
            <span className="flex flex-col leading-tight" data-id="element-184" data-mp="1wfs0utt0p0i">
              <span className="font-serif text-base text-white sm:text-lg" data-id="element-185" data-mp="1y0l0g0gzzw9">
                Gerry Holmes, CPA
              </span>
              <span className="text-[10px] uppercase tracking-widest text-slateink-500" data-id="element-186" data-mp="3t9aht6oq2mrb">
                Board Director Candidate
              </span>
            </span>
          </Link>

          <div className="flex items-center gap-3" data-id="element-187" data-mp="1wequi9d64v6e">
            <Link to="/contact" className="hidden border border-gold-500 px-5 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-gold-400 transition-colors hover:bg-gold-500 hover:text-navy-950 sm:inline-block" data-id="element-188" data-mp="1hojk8gxbeigs">
              Board Bio / CV
            </Link>
            <button type="button" aria-label={open ? 'Close section menu' : 'Open section menu'} aria-expanded={open} onClick={() => setOpen(v => !v)} className="p-2 text-white xl:hidden" data-id="element-189" data-mp="1cpgib5cmssd1">
              {open ? <XIcon className="h-5 w-5" data-id="element-190" data-mp="2t2ngjtrdkip0" /> : <MenuIcon className="h-5 w-5" data-id="element-191" data-mp="2t3ghuf7kefzr" />}
            </button>
          </div>
        </div>
      </div>

      {/* Section rail — all ten sections visible, never hidden */}
      <nav aria-label="Site sections" className="hidden border-b border-white/10 bg-navy-900/80 xl:block" data-id="element-192" data-mp="mfprw4snnmig">
        <ul className="mx-auto flex max-w-content items-stretch px-6 lg:px-8" data-id="element-193" data-mp="hheitwa6pg1a">
          {SECTIONS.map(section => <li key={section.to} className="flex-1" data-id="element-194" data-mp="w6amlh57k6w3">
              <NavLink to={section.to} end={section.to === '/'} className={({
            isActive
          }) => ['group flex h-full flex-col justify-center gap-1 border-r border-white/5 px-3 py-3 text-left transition-colors', isActive ? 'bg-navy-800 text-white' : 'text-slateink-300 hover:bg-navy-800/60 hover:text-white'].join(' ')} data-id="element-195" data-mp="rczgxjc4tw5r">
                {({
              isActive
            }) => <>
                    <span className={['font-serif text-[11px]', isActive ? 'text-gold-400' : 'text-slateink-500'].join(' ')} data-id="element-196" data-mp="3bwdrpupakukq">
                      {section.index}
                    </span>
                    <span className="text-[11px] font-medium uppercase leading-tight tracking-wider" data-id="element-197" data-mp="2cxwg4h4aee1p">
                      {section.navLabel}
                    </span>
                  </>}
              </NavLink>
            </li>)}
        </ul>
      </nav>

      {open ? <nav aria-label="Sections" className="max-h-[70vh] overflow-y-auto border-b border-white/10 bg-navy-950 px-6 py-3 xl:hidden" data-id="element-198" data-mp="1p8bt9n50iwn5">
          <ul className="divide-y divide-white/5" data-id="element-199" data-mp="1xzc3uateplvn">
            {SECTIONS.map(section => <li key={section.to} data-id="element-200" data-mp="11ho7bxy9i6hl">
                <NavLink to={section.to} end={section.to === '/'} className={({
            isActive
          }) => ['flex items-baseline gap-4 py-3.5', isActive ? 'text-gold-400' : 'text-slateink-300'].join(' ')} data-id="element-201" data-mp="11gmxtxww9s1z">
                  <span className="font-serif text-xs text-slateink-500" data-id="element-202" data-mp="oyu1q21z0dji">
                    {section.index}
                  </span>
                  <span className="text-[13px] uppercase tracking-wider" data-id="element-203" data-mp="jz7mxo6hup8l">
                    {section.label}
                  </span>
                </NavLink>
              </li>)}
          </ul>
        </nav> : null}
    </header>;
}